module.exports = __webpack_public_path__ + "static/flags/KU-0f72100afb5e99a980c3fc882d3c436d.gif";